"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import generalFormatter from "../formatters/general";
function matchIcon(a, b) {
  return /* @__PURE__ */ jsx("div", { className: a === b ? "fi-checkbox success" : "fi-x-circle alert" });
}
function formatDate(date) {
  return moment(date).format("MM/DD/YYYY");
}
function invoiceAmount(invoice) {
  return generalFormatter.currency(invoice.invoiceAmount);
}
function warningClass(a, b) {
  return a === b ? "" : "mismatched";
}
const DuplicateBrokerInvoiceConfirmation = React.createClass({
  getInitialState() {
    return {
      decisionError: false,
      storingNotDupe: false,
      savingDupe: false
    };
  },
  saveNotDupe() {
    this.setState({ storingNotDupe: true, decisionError: false });
    this.props.onClose().then((resp) => {
      if (resp === false)
        this.setState({
          decisionError: "Failure storing 'not duplicate' decision"
        });
    }).finally(() => this.setState({ storingNotDupe: false }));
  },
  saveDupe() {
    this.setState({ savingDupe: true, decisionError: false });
    this.props.onMarkAsDupe().then((resp) => {
      if (resp === false)
        this.setState({
          decisionError: "Failure storing 'yes duplicate' decision"
        });
    }).finally(() => this.setState({ savingDupe: false }));
  },
  render: function() {
    const saving = this.state.storingNotDupe || this.state.savingDupe;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "DuplicateBrokerInvoiceConfirmation",
        className: "load-assigner__duplicate-broker-invoice-confirmation",
        children: [
          /* @__PURE__ */ jsxs("h3", { children: [
            "Is this a duplicate of invoice",
            " ",
            this.props.approvedInvoice.invoiceNumber,
            " for load",
            " ",
            this.props.approvedInvoice.loadId,
            "?"
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "alert-box--caution", children: [
            /* @__PURE__ */ jsx("em", { children: "Warning - " }),
            /* @__PURE__ */ jsxs("span", { children: [
              "There is already an approved invoice for ",
              this.props.carrierName,
              " on the load"
            ] })
          ] }),
          /* @__PURE__ */ jsxs("table", { className: "duplicate-table", children: [
            /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
              /* @__PURE__ */ jsx("th", { children: "Invoice details" }),
              /* @__PURE__ */ jsx("th", { children: "Approved Invoice" }),
              /* @__PURE__ */ jsx("th", { children: "Invoice on current email" }),
              /* @__PURE__ */ jsx("th", { children: "Match" })
            ] }) }),
            /* @__PURE__ */ jsxs("tbody", { children: [
              /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("td", { children: "Sender Email" }),
                /* @__PURE__ */ jsx("td", { children: this.props.approvedInvoice.senderEmail }),
                /* @__PURE__ */ jsx(
                  "td",
                  {
                    className: warningClass(
                      this.props.approvedInvoice.senderEmail,
                      this.props.submission.senderEmail
                    ),
                    children: this.props.submission.senderEmail
                  }
                ),
                /* @__PURE__ */ jsx("td", { children: matchIcon(
                  this.props.approvedInvoice.senderEmail,
                  this.props.submission.senderEmail
                ) })
              ] }),
              /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("td", { children: "Invoice Amount" }),
                /* @__PURE__ */ jsx("td", { children: invoiceAmount(this.props.approvedInvoice) }),
                /* @__PURE__ */ jsx(
                  "td",
                  {
                    className: warningClass(
                      this.props.approvedInvoice.invoiceAmount,
                      this.props.submission.invoiceAmount
                    ),
                    children: invoiceAmount(this.props.submission)
                  }
                ),
                /* @__PURE__ */ jsx("td", { children: matchIcon(
                  this.props.approvedInvoice.invoiceAmount,
                  this.props.submission.invoiceAmount
                ) })
              ] }),
              /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("td", { children: "Invoice Number" }),
                /* @__PURE__ */ jsx("td", { children: this.props.approvedInvoice.invoiceNumber }),
                /* @__PURE__ */ jsx(
                  "td",
                  {
                    className: warningClass(
                      this.props.approvedInvoice.invoiceNumber,
                      this.props.submission.invoiceNumber
                    ),
                    children: this.props.submission.invoiceNumber
                  }
                ),
                /* @__PURE__ */ jsx("td", { children: matchIcon(
                  this.props.approvedInvoice.invoiceNumber,
                  this.props.submission.invoiceNumber
                ) })
              ] }),
              /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("td", { children: "Invoice Date" }),
                /* @__PURE__ */ jsx("td", { children: formatDate(this.props.approvedInvoice.invoiceDate) }),
                /* @__PURE__ */ jsx(
                  "td",
                  {
                    className: warningClass(
                      this.props.approvedInvoice.invoiceDate.getTime(),
                      this.props.submission.invoiceDate.getTime()
                    ),
                    children: formatDate(this.props.submission.invoiceDate)
                  }
                ),
                /* @__PURE__ */ jsx("td", { children: matchIcon(
                  this.props.approvedInvoice.invoiceDate.getTime(),
                  this.props.submission.invoiceDate.getTime()
                ) })
              ] })
            ] })
          ] }),
          this.state.decisionError && /* @__PURE__ */ jsx("div", { className: "alert-box alert-box--caution centered", children: this.state.decisionError }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    disabled: saving,
                    onClick: this.saveNotDupe,
                    className: ["button--cancel", ...saving ? ["disabled"] : []].join(
                      " "
                    ),
                    children: "No"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    disabled: saving,
                    onClick: this.saveDupe,
                    className: ["button", ...saving ? ["disabled"] : []].join(" "),
                    children: "Yes, Ignore the duplicate"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
});
export default DuplicateBrokerInvoiceConfirmation;
